import { render } from "./ReportManagerPage.vue?vue&type=template&id=06f941e4"
import script from "./ReportManagerPage.vue?vue&type=script&lang=js"
export * from "./ReportManagerPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__